<!-- =========================================================================================
  File Name: UserView.vue
  Description: User View page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
	<div id="page-user-view">
		<vs-alert
			color="danger"
			:title="$t('TimeWindow.TimeWindowNotFound.Title')"
			:active.sync="time_window_not_found"
		>
			{{
				$t("TimeWindow.TimeWindowNotFound.Text1") +
				" " +
				$route.params.id +
				" " +
				$t("TimeWindow.TimeWindowNotFound.Text2")
			}}
			<span>
				<span>{{ $t("Check") }} </span>
				<router-link :to="{name: 'app-time-window-list'}" class="text-inherit underline">{{
					$t("TimeWindow.ListOfTimeWindows")
				}}</router-link>
			</span>
		</vs-alert>
		<div id="user-data" v-if="timeWindowData">
			<vx-card :title="$t('Information')" class="mb-base">
				<div class="vx-row">
					<div class="vx-col flex-1" id="account-info-col-1">
						<table>
							<caption></caption>
							<thead>
								<tr>
									<th scope="col"></th>
								</tr>
							</thead>
							<tr>
								<td class="font-semibold">{{ $t("Routing.Table.Identification") }}</td>
								<td>{{ timeWindowData.id }}</td>
							</tr>
							<tr>
								<td class="font-semibold">{{ $t("Routing.Table.Name") }}</td>
								<td>{{ timeWindowData.name }}</td>
							</tr>
						</table>
					</div>

					<div class="vx-col flex-1" id="account-info-col-2">
						<table>
							<caption></caption>
							<thead>
								<tr>
									<th scope="col"></th>
								</tr>
							</thead>
							<tr>
								<td class="font-semibold">{{ $t("TimeWindow.Duration") }}</td>
								<td>{{ timeWindowData.duration }}</td>
							</tr>
						</table>
					</div>

					<div class="vx-col w-full flex mt-base justify-end" id="account-manage-buttons">
						<vs-button
							type="border"
							icon-pack="feather"
							icon="icon-edit"
							class="mr-4"
							color="success"
							:title="windowWidth > 620 ? null : $t('Crud.Update')"
							:size="iconSize"
							:to="{
								name: 'app-time-window-edit',
								params: {id: $route.params.id},
							}"
							>{{ windowWidth > 620 ? $t("Crud.Update") : null }}
						</vs-button>
						<vs-button
							type="border"
							color="danger"
							icon-pack="feather"
							icon="icon-trash"
							class="mr-4"
							:title="windowWidth > 620 ? null : $t('Crud.Delete')"
							:size="iconSize"
							@click="confirmDeleteRecord"
							>{{ windowWidth > 620 ? $t("Crud.Delete") : null }}
						</vs-button>
						<vs-button
							type="border"
							color="primary"
							icon-pack="feather"
							icon="icon-list"
							:title="windowWidth > 620 ? null : $t('TimeWindow.ListOfTimeWindows')"
							:size="iconSize"
							:to="{name: 'app-time-window-list'}"
							>{{ windowWidth > 620 ? $t("TimeWindow.ListOfTimeWindows") : null }}</vs-button
						>
					</div>
				</div>
				<vs-divider class="mt-base mb-base"></vs-divider>
				<template lang="html">
					<vs-tabs>
						<vs-tab
							:label="$t('TimeWindow.Schedule') | capitalize"
							icon-pack="feather"
							icon="icon-calendar"
							class="mb-base mt-base"
						>
							<time-calendar
								ref="timeWindowCalendar"
								:viewData="true"
								:isMaximize="false"
								:cronExpression="timeWindowData.cron"
								:duration="timeWindowData.duration ? timeWindowData.duration : '12:00:00'"
								:softTime="soft_time_window"
								:isSoftTimeWindow="!isSoftTimeWindow"
							/>
						</vs-tab>
						<vs-tab
							:label="$t('VisitPoints.AssignedVisitPoints') | capitalize"
							icon-pack="feather"
							icon="icon-map-pin"
							class="mb-base mt-base"
						>
							<assigned-visit-point-list
								v-if="visitPointIds.length > 0"
								:isDemand="false"
								:isTypeService="false"
								:remove="false"
								:redirect="true"
								:visit_point_ids="visitPointIds"
								:configColumns="false"
							></assigned-visit-point-list>
							<vx-card v-else no-shadow card-border>
								<vs-alert active class="mb-5" color="primary">
									<span> {{ $t("VisitPoints.NoAssignedVisitPoints") }} </span>
								</vs-alert>
							</vx-card>
						</vs-tab>
					</vs-tabs>
				</template>
			</vx-card>
		</div>
	</div>
</template>

<script>
import vSelect from "vue-select";
import "swiper/dist/css/swiper.min.css";
import {swiper, swiperSlide} from "vue-awesome-swiper";
import AssignedVisitPointList from "../visit-point/list/AssignedVisitPointList.vue";
import TimeCalendar from "@/components/shared/TimeCalendar.vue";
import moduleTimeWindow from "@/store/time-window/moduleTimeWindow.js";

export default {
	components: {
		vSelect,
		swiper,
		swiperSlide,
		AssignedVisitPointList,
		TimeCalendar,
	},
	data() {
		return {
			timeWindowData: null,
			time_window_not_found: false,
			settings: {
				maxScrollbarLength: 60,
				wheelSpeed: 0.6,
			},
		};
	},
	computed: {
		visitPointIds() {
			return this.timeWindowData["visit_point_id"] && this.timeWindowData["visit_point_id"] !== null
				? this.timeWindowData["visit_point_id"]
				: [];
		},
		windowWidth() {
			return this.$store.state.windowWidth;
		},
		iconSize() {
			return this.$store.state.windowWidth < 620 ? "small" : "medium";
		},
		soft_time_window() {
			return {
				before_soft_duration: this.timeWindowData.before_soft_duration,
				after_soft_duration: this.timeWindowData.after_soft_duration,
				before_soft_cost: parseFloat(this.timeWindowData.before_soft_cost),
				after_soft_cost: parseFloat(this.timeWindowData.after_soft_cost),
			};
		},
		isSoftTimeWindow() {
			return (
				this.timeWindowData.before_soft_duration === "00:00:00" &&
				this.timeWindowData.after_soft_duration === "00:00:00" &&
				this.timeWindowData.before_soft_cost === 0 &&
				this.timeWindowData.after_soft_cost === 0
			);
		},
	},
	methods: {
		openLoading() {
			this.$vs.loading();
		},
		closeLoading() {
			this.$vs.loading.close();
		},
		confirmDeleteRecord() {
			this.$vs.dialog({
				type: "confirm",
				color: "danger",
				title: this.$t("Confirm"),
				text:
					this.$t("TimeWindow.DeleteTimeWindow.Text1") +
					` "${this.timeWindowData.name}"? ` +
					this.$t("TimeWindow.DeleteTimeWindow.Text2"),
				accept: this.deleteRecord,
				acceptText: this.$t("Accept"),
				cancelText: this.$t("Cancel"),
			});
		},
		deleteRecord() {
			/* Below two lines are just for demo purpose */
			this.$store
				.dispatch("moduleTimeWindow/deleteById", this.timeWindowData.id)
				.then((res) => {
					this.$router.push({name: "app-time-window-list"});
					this.showDeleteSuccess();
				})
				.catch((err) => {
					if (err.response.status === 404) {
						return;
					}
					console.error(err);
				});
		},
		showDeleteSuccess() {
			this.$vs.notify({
				color: "success",
				title: this.$t("TimeWindow.CellRenderer.DeleteSuccess.Title"),
				text: this.$t("TimeWindow.CellRenderer.DeleteSuccess.Text"),
			});
		},
	},
	created() {
		if (!moduleTimeWindow.isRegistered) {
			this.$store.registerModule("moduleTimeWindow", moduleTimeWindow);
			moduleTimeWindow.isRegistered = true;
		}
		const id = parseInt(this.$route.params.id);
		this.openLoading();
		this.$store
			.dispatch("moduleTimeWindow/timeWindowFilter", {id: [id]})
			.then((res) => {
				this.timeWindowData = res.records[0];
				this.closeLoading();
				return res.records;
			})
			.catch((err) => {
				this.closeLoading();
				if (err.status === 400) {
					this.time_window_not_found = true;
					return;
				}
				console.error(err);
			});
	},
};
</script>

<style lang="scss">
#avatar-col {
	width: 10rem;
}

#page-user-view {
	table {
		td {
			vertical-align: top;
			min-width: 140px;
			padding-bottom: 0.8rem;
			word-break: break-all;
		}

		&:not(.permissions-table) {
			td {
				@media screen and (max-width: 370px) {
					display: block;
				}
			}
		}
	}
}

@media screen and (min-width: 1201px) and (max-width: 1211px),
	only screen and (min-width: 636px) and (max-width: 991px) {
	#account-info-col-1 {
		width: calc(100% - 12rem) !important;
	}
}
.scroll-area {
	margin: auto;
	width: 100%;
	min-height: 400px;
	max-height: 450px;
}
</style>
